const constants = {
    DOMAIN:
      process.env.NODE_ENV === "development"
        ? "http://localhost:5001"
        :  "https://printverse.synquic.in",
  }
  
  module.exports = constants